import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { PaginationInfo } from '../api/pc-chat-api.types';
import { ChatMessage, Conversation, ConversationStatus, FeedbackRating } from './chat.models';
import { ConversationSearchResponse } from '../search/search.models';

export type ConversationListPage = {
  conversations: Conversation[];
  pagination: PaginationInfo;
};

export type CreateResponseArgs = {
  input: unknown;
  conversationId: string | null;
  stream: boolean;
  model?: string;
  deepResearch?: boolean;
  retry?: boolean;
  edited?: boolean;
};

export type ConversationMessagesResponse = {
  messages: ChatMessage[];
  status: ConversationStatus;
  deepResearch: boolean;
  pagination: PaginationInfo;
};

export type FeedbackSubmitResult = {
  feedbackRating: FeedbackRating;
  feedbackComment: string | null;
  feedbackAt: string;
};

export interface ChatBackend {
  listConversations(page?: number, limit?: number): Observable<ConversationListPage>;
  searchConversations(query: string, limit?: number): Observable<ConversationSearchResponse>;
  listMessages(
    conversationId: string,
    page?: number,
    limit?: number,
  ): Observable<ConversationMessagesResponse>;
  renameConversation(conversationId: string, title: string): Observable<void>;
  deleteConversation(conversationId: string): Observable<void>;
  submitFeedback(
    conversationId: string,
    rating: string,
    comment?: string,
  ): Observable<FeedbackSubmitResult>;
  createResponse(args: CreateResponseArgs): Observable<unknown>;
  stopConversation(conversationId: string): Observable<void>;
}

export const CHAT_BACKEND = new InjectionToken<ChatBackend>('CHAT_BACKEND');
